import React, { useState } from 'react';
import { KeyRound, Loader2 } from 'lucide-react';
import api from '@/lib/axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuth } from '@/context/AuthContext';

export default function ForcePasswordChange() {
  const { user, loading: authLoading } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [loading, setLoading] = useState(false);

  if (authLoading) return null;
  if (!user) {
    window.location.href = '/login';
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error('Neues Passwort muss mindestens 8 Zeichen lang sein');
    if (next !== repeat) return toast.error('Passwörter stimmen nicht überein');
    setLoading(true);
    try {
      const r = await api.post('/auth/change-password', { current_password: current, new_password: next });
      localStorage.setItem('user', JSON.stringify(r.data));
      toast.success('Passwort geändert');
      window.location.href = '/';
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Passwort-Änderung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-8">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8" data-testid="force-password-change-form">
          <div className="text-center mb-6">
            <div className="mx-auto w-12 h-12 rounded-full bg-brand-red/10 flex items-center justify-center mb-4">
              <KeyRound className="w-6 h-6 text-brand-red" />
            </div>
            <h1 className="text-xl font-bold text-slate-900">Passwort ändern</h1>
            <p className="text-sm text-slate-500 mt-1">
              Bitte ersetzen Sie Ihr Initial-Passwort, bevor Sie fortfahren.
            </p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="current">Aktuelles Passwort</Label>
              <Input id="current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
                     required className="h-10" data-testid="current-password-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="next">Neues Passwort <span className="text-xs text-slate-400 font-normal">(min. 8 Zeichen)</span></Label>
              <Input id="next" type="password" value={next} onChange={(e) => setNext(e.target.value)}
                     required className="h-10" data-testid="new-password-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="repeat">Neues Passwort wiederholen</Label>
              <Input id="repeat" type="password" value={repeat} onChange={(e) => setRepeat(e.target.value)}
                     required className="h-10" data-testid="repeat-password-input" />
            </div>
            <Button type="submit" disabled={loading}
                    className="w-full bg-slate-900 text-white hover:bg-slate-800 h-10"
                    data-testid="change-password-submit">
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
              Passwort ändern & fortfahren
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
